import { bearCallLadder } from 'utils/shared/optionProfitCalculator/bearCallLadder';
import { bearCallSpread } from 'utils/shared/optionProfitCalculator/bearCallSpread';
import { bearPutLadder } from 'utils/shared/optionProfitCalculator/bearPutLadder';
import { bearPutSpread } from 'utils/shared/optionProfitCalculator/bearPutSpread';
import { bullCallLadder } from 'utils/shared/optionProfitCalculator/bullCallLadder';
import { bullCallSpread } from 'utils/shared/optionProfitCalculator/bullCallSpread';
import { bullPutLadder } from 'utils/shared/optionProfitCalculator/bullPutLadder';
import { bullPutSpread } from 'utils/shared/optionProfitCalculator/bullPutSpread';
import { calendarCallSpread } from 'utils/shared/optionProfitCalculator/calendarCallSpread';
import { calendarPutSpread } from 'utils/shared/optionProfitCalculator/calendarPutSpread';
import { callBrokenWing } from 'utils/shared/optionProfitCalculator/callBrokenWing';
import { callRatioBackspread } from 'utils/shared/optionProfitCalculator/callRatioBackspread';
import { callRatioSpread } from 'utils/shared/optionProfitCalculator/callRatioSpread';
import { cashSecuredPut } from 'utils/shared/optionProfitCalculator/cashSecuredPut';
import { collar } from 'utils/shared/optionProfitCalculator/collar';
import { coveredCall } from 'utils/shared/optionProfitCalculator/coveredCall';
import { coveredShortStraddle } from 'utils/shared/optionProfitCalculator/coveredShortStraddle';
import { coveredShortStrangle } from 'utils/shared/optionProfitCalculator/coveredShortStrangle';
import { diagonalCallSpread } from 'utils/shared/optionProfitCalculator/diagonalCallSpread';
import { diagonalPutSpread } from 'utils/shared/optionProfitCalculator/diagonalPutSpread';
import { doubleDiagonal } from 'utils/shared/optionProfitCalculator/doubleDiagonal';
import { guts } from 'utils/shared/optionProfitCalculator/guts';
import { inverseCallBrokenWing } from 'utils/shared/optionProfitCalculator/inverseCallBrokenWing';
import { inverseIronButterfly } from 'utils/shared/optionProfitCalculator/inverseIronButterfly';
import { inverseIronCondor } from 'utils/shared/optionProfitCalculator/inverseIronCondor';
import { inversePutBrokenWing } from 'utils/shared/optionProfitCalculator/inversePutBrokenWing';
import { ironButterfly } from 'utils/shared/optionProfitCalculator/ironButterfly';
import { ironCondor } from 'utils/shared/optionProfitCalculator/ironCondor';
import { jadeLizard } from 'utils/shared/optionProfitCalculator/jadeLizard';
import { longCall } from 'utils/shared/optionProfitCalculator/longCall';
import { longCallButterfly } from 'utils/shared/optionProfitCalculator/longCallButterfly';
import { longCallCondor } from 'utils/shared/optionProfitCalculator/longCallCondor';
import { longCombo } from 'utils/shared/optionProfitCalculator/longCombo';
import { longPut } from 'utils/shared/optionProfitCalculator/longPut';
import { longPutButterfly } from 'utils/shared/optionProfitCalculator/longPutButterfly';
import { longPutCondor } from 'utils/shared/optionProfitCalculator/longPutCondor';
import { longSyntheticFuture } from 'utils/shared/optionProfitCalculator/longSyntheticFuture';
import { protectivePut } from 'utils/shared/optionProfitCalculator/protectivePut';
import { putBrokenWing } from 'utils/shared/optionProfitCalculator/putBrokenWing';
import { putRatioBackspread } from 'utils/shared/optionProfitCalculator/putRatioBackspread';
import { putRatioSpread } from 'utils/shared/optionProfitCalculator/putRatioSpread';
import { reverseJadeLizard } from 'utils/shared/optionProfitCalculator/reverseJadeLizard';
import { shortCall } from 'utils/shared/optionProfitCalculator/shortCall';
import { shortCallButterfly } from 'utils/shared/optionProfitCalculator/shortCallButterfly';
import { shortCallCondor } from 'utils/shared/optionProfitCalculator/shortCallCondor';
import { shortCombo } from 'utils/shared/optionProfitCalculator/shortCombo';
import { shortGuts } from 'utils/shared/optionProfitCalculator/shortGuts';
import { shortPut } from 'utils/shared/optionProfitCalculator/shortPut';
import { shortPutButterfly } from 'utils/shared/optionProfitCalculator/shortPutButterfly';
import { shortPutCondor } from 'utils/shared/optionProfitCalculator/shortPutCondor';
import { shortStraddle } from 'utils/shared/optionProfitCalculator/shortStraddle';
import { shortStrangle } from 'utils/shared/optionProfitCalculator/shortStrangle';
import { shortSyntheticFuture } from 'utils/shared/optionProfitCalculator/shortSyntheticFuture';
import { straddle } from 'utils/shared/optionProfitCalculator/straddle';
import { strangle } from 'utils/shared/optionProfitCalculator/strangle';
import { strap } from 'utils/shared/optionProfitCalculator/strap';
import { strip } from 'utils/shared/optionProfitCalculator/strip';
import { syntheticPut } from 'utils/shared/optionProfitCalculator/syntheticPut';

export const strategies = [
  { name: 'Long Call', slug: 'long-call', function: longCall, skillLevel: 'Novice' },
  { name: 'Long Put', slug: 'long-put', function: longPut, skillLevel: 'Novice' },
  {
    name: 'Bear Call Ladder',
    slug: 'bear-call-ladder',
    function: bearCallLadder,
    skillLevel: 'Advanced',
  },
  {
    name: 'Bear Call Spread',
    slug: 'bear-call-spread',
    function: bearCallSpread,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Bear Put Ladder',
    slug: 'bear-put-ladder',
    function: bearPutLadder,
    skillLevel: 'Advanced',
  },
  {
    name: 'Bear Put Spread',
    slug: 'bear-put-spread',
    function: bearPutSpread,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Bull Call Ladder',
    slug: 'bull-call-ladder',
    function: bullCallLadder,
    skillLevel: 'Advanced',
  },
  {
    name: 'Bull Call Spread',
    slug: 'bull-call-spread',
    function: bullCallSpread,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Bull Put Ladder',
    slug: 'bull-put-ladder',
    function: bullPutLadder,
    skillLevel: 'Advanced',
  },
  {
    name: 'Bull Put Spread',
    slug: 'bull-put-spread',
    function: bullPutSpread,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Calendar Call Spread',
    slug: 'calendar-call-spread',
    function: calendarCallSpread,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Calendar Put Spread',
    slug: 'calendar-put-spread',
    function: calendarPutSpread,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Call Broken Wing',
    slug: 'call-broken-wing',
    function: callBrokenWing,
    skillLevel: 'Advanced',
  },
  {
    name: 'Call Ratio Backspread',
    slug: 'call-ratio-backspread',
    function: callRatioBackspread,
    skillLevel: 'Advanced',
  },
  {
    name: 'Call Ratio Spread',
    slug: 'call-ratio-spread',
    function: callRatioSpread,
    skillLevel: 'Expert',
  },
  {
    name: 'Cash Secured Put',
    slug: 'cash-secured-put',
    function: cashSecuredPut,
    skillLevel: 'Novice',
  },
  { name: 'Collar', slug: 'collar', function: collar, skillLevel: 'Intermediate' },
  { name: 'Covered Call', slug: 'covered-call', function: coveredCall, skillLevel: 'Novice' },
  {
    name: 'Covered Short Straddle',
    slug: 'covered-short-straddle',
    function: coveredShortStraddle,
    skillLevel: 'Advanced',
  },
  {
    name: 'Covered Short Strangle',
    slug: 'covered-short-strangle',
    function: coveredShortStrangle,
    skillLevel: 'Advanced',
  },
  {
    name: 'Diagonal Call Spread',
    slug: 'diagonal-call-spread',
    function: diagonalCallSpread,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Diagonal Put Spread',
    slug: 'diagonal-put-spread',
    function: diagonalPutSpread,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Double Diagonal',
    slug: 'double-diagonal',
    function: doubleDiagonal,
    skillLevel: 'Expert',
  },
  { name: 'Guts', slug: 'guts', function: guts, skillLevel: 'Expert' },
  {
    name: 'Inverse Call Broken Wing',
    slug: 'inverse-call-broken-wing',
    function: inverseCallBrokenWing,
    skillLevel: 'Advanced',
  },
  {
    name: 'Inverse Iron Butterfly',
    slug: 'inverse-iron-butterfly',
    function: inverseIronButterfly,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Inverse Iron Condor',
    slug: 'inverse-iron-condor',
    function: inverseIronCondor,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Inverse Put Broken Wing',
    slug: 'inverse-put-broken-wing',
    function: inversePutBrokenWing,
    skillLevel: 'Advanced',
  },
  {
    name: 'Iron Butterfly',
    slug: 'iron-butterfly',
    function: ironButterfly,
    skillLevel: 'Intermediate',
  },
  { name: 'Iron Condor', slug: 'iron-condor', function: ironCondor, skillLevel: 'Intermediate' },
  { name: 'Jade Lizard', slug: 'jade-lizard', function: jadeLizard, skillLevel: 'Advanced' },
  {
    name: 'Long Call Butterfly',
    slug: 'long-call-butterfly',
    function: longCallButterfly,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Long Call Condor',
    slug: 'long-call-condor',
    function: longCallCondor,
    skillLevel: 'Intermediate',
  },
  { name: 'Long Combo', slug: 'long-combo', function: longCombo, skillLevel: 'Expert' },
  {
    name: 'Long Put Butterfly',
    slug: 'long-put-butterfly',
    function: longPutButterfly,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Long Put Condor',
    slug: 'long-put-condor',
    function: longPutCondor,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Long Synthetic Future',
    slug: 'long-synthetic-future',
    function: longSyntheticFuture,
    skillLevel: 'Expert',
  },
  { name: 'Protective Put', slug: 'protective-put', function: protectivePut, skillLevel: 'Novice' },
  {
    name: 'Put Broken Wing',
    slug: 'put-broken-wing',
    function: putBrokenWing,
    skillLevel: 'Advanced',
  },
  {
    name: 'Put Ratio Backspread',
    slug: 'put-ratio-backspread',
    function: putRatioBackspread,
    skillLevel: 'Advanced',
  },
  {
    name: 'Put Ratio Spread',
    slug: 'put-ratio-spread',
    function: putRatioSpread,
    skillLevel: 'Expert',
  },
  {
    name: 'Reverse Jade Lizard',
    slug: 'reverse-jade-lizard',
    function: reverseJadeLizard,
    skillLevel: 'Advanced',
  },
  { name: 'Short Call', slug: 'short-call', function: shortCall, skillLevel: 'Advanced' },
  {
    name: 'Short Call Butterfly',
    slug: 'short-call-butterfly',
    function: shortCallButterfly,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Short Call Condor',
    slug: 'short-call-condor',
    function: shortCallCondor,
    skillLevel: 'Intermediate',
  },
  { name: 'Short Combo', slug: 'short-combo', function: shortCombo, skillLevel: 'Expert' },
  { name: 'Short Guts', slug: 'short-guts', function: shortGuts, skillLevel: 'Expert' },
  { name: 'Short Put', slug: 'short-put', function: shortPut, skillLevel: 'Advanced' },
  {
    name: 'Short Put Butterfly',
    slug: 'short-put-butterfly',
    function: shortPutButterfly,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Short Put Condor',
    slug: 'short-put-condor',
    function: shortPutCondor,
    skillLevel: 'Intermediate',
  },
  {
    name: 'Short Straddle',
    slug: 'short-straddle',
    function: shortStraddle,
    skillLevel: 'Advanced',
  },
  {
    name: 'Short Strangle',
    slug: 'short-strangle',
    function: shortStrangle,
    skillLevel: 'Advanced',
  },
  {
    name: 'Short Synthetic Future',
    slug: 'short-synthetic-future',
    function: shortSyntheticFuture,
    skillLevel: 'Expert',
  },
  { name: 'Straddle', slug: 'straddle', function: straddle, skillLevel: 'Intermediate' },
  { name: 'Strangle', slug: 'strangle', function: strangle, skillLevel: 'Intermediate' },
  { name: 'Strap', slug: 'strap', function: strap, skillLevel: 'Expert' },
  { name: 'Strip', slug: 'strip', function: strip, skillLevel: 'Expert' },
  { name: 'Synthetic Put', slug: 'synthetic-put', function: syntheticPut, skillLevel: 'Advanced' },
];
